import {IApiEndpoint, IOperationResponse, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {siteMapApi} from "@localization/siteMap/siteMap.ts";
import type {IContrato} from "@models/contratos/contrato.js";
import type {IContratoFilterDto} from "@models/contratos/dto.js";

export const _ContratosEndpoints = {
    GetContratos: (filters: IContratoFilterDto, pagination: IPagination): IApiEndpoint<IContrato[]> => ({
        url: '/api/Contratos/GetContratos',
        pagination: pagination,
        query: filters,
        method: "GET"
    }),
    createContrato: (contrato: IContrato): IApiEndpoint => ({
        url: '/api/Contratos/CreateContrato',
        body: contrato,
        method: "POST"
    }),
    getContratosPesquisa: (search: string, pagination: IPagination): IApiEndpoint => ({
        url: '/api/Contratos/GetContratosPesquisa',
        pagination: pagination,
        query: {search},
        method: "GET"
    }),
    UpdateContrato: (contrato: IContrato): IApiEndpoint<IContrato> => ({
        url: '/api/Contratos/UpdateContrato',
        body: contrato,
        method: "PUT"
    })

}


export const GetContratosPesquisa = (search: string, pagination: IPagination): Promise<IOperationResponse<IContrato[]>> => {
    const endpoint = _ContratosEndpoints.getContratosPesquisa(search, pagination);

    return siteMapApi.fetch(endpoint);
}


